import React from 'react'
import ExpiredMedicine from './expiredMedicine'

export default (props) => {
    return <ExpiredMedicine isExpired={false} onCancel={()=>props.onCancel()} />
}